import React, { useState, useEffect, useCallback } from "react";
import {
  Layout,
  Table,
  Button,
  Typography,
  Space,
  Row,
  Col,
  Input,
  Segmented,
  message,
  Tag,
  Avatar,
  Tooltip,
} from "antd";
import {
  VideoCameraOutlined,
  UploadOutlined,
  SearchOutlined,
  DeleteOutlined,
  EyeOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { FiSearch } from "react-icons/fi";
import {
  StyledLayout,
  StyledHeader,
  StyledTable,
  Wrapper,
  SegmentWrapper,
  TopSection,
  TopTextWrapper,
} from "./styled";
import UploadVideoModal from "./UploadVideoModal";
import AssignVideoModal from "../AssignVideoModal";
import DeleteConfirmationModal from "../../physician_page/component/DeleteConfirmationModal";
import videos from "../../../../services/videos";
import { debounce, notify } from "../../../../utils/helper";
import {
  CustomButton,
  CustomSecondaryButton,
} from "../../physician_page/styled";
import { extractToken } from "../../../../utils/localStorage";
import VideoPreviewModal from "./VideoPreviewModal";
import moment from "moment";
import Filter from "../../../table-item/filter/Filter";
import { apiGet } from "../../../../utils/axios";
import { domainUrl } from "../../../../utils/domainUrls";
import { titleFormat } from "../../../../utils/utils";
import { capitalizeFirstLetter } from "../../../../utils/utils";
import AssisgnedVideoModal from "./AssisgnedVideoModal";
import { physicianService } from "../../../../services/user";
import { CustomTitle, CustomSubTitle } from "../../physician_page/styled";
import { CustomSearchContainer } from "../../../table-item";
import { globalRoles } from "../../../../utils/roles";

const { Title, Text } = Typography;

const VideoLibraryPage = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isAssignModal, setIsAssignModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedTab, setSelectedTab] = useState("List");
  const [allVideos, setAllVideos] = useState([]);
  const [allRequestedVideos, setAllRequestedVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isPreviewModalVisible, setIsPreviewModalVisible] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [count, setCount] = useState(0);
  const [sortingColumn, setSortingColumn] = useState("");
  const [videosList, setVideosList] = useState(null);
  const [show, setShow] = useState(false);
  const [filterTab, setFilterTab] = useState([]);
  const [allVideoSpecialty, setAllVideoSpecialty] = useState([]);
  const [physicianDetailModal, setPhysicianDetailModal] = useState(false);
  const [physicianData, setPhysicianData] = useState([]);
  const [allPhysician, setAllPhysician] = useState([]);
  const [selectedPhysician, setSelectedPhysician] = useState([]);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [videoTypeFilter, setVideoTypeFilter] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState([]);
  const [videoTypeSorting, setVideoTypeSorting] = useState('')
  const user = extractToken();
  const isLibraryManager = user?.role === "LibraryManager";
  const isPhysician = user?.role === "Physician";
  const superAdmin = user?.role === "SuperAdmin";

  const columns = [
    {
      title: <div className="font-14">Title</div>,
      dataIndex: "title",
      key: "title",
      width: 250,
      ellipsis: true,
      sorter: (a, b) => String(a?.title || "").localeCompare(String(b?.title || "")),
    },

    {
      title: "Assigned To",
      dataIndex: "physician",
      align: "center",
      key: "physician",
      width: 150,
      render: (_, record) => {
        if (!Array.isArray(record.physician)) return <Tag>N/A</Tag>;

        const names = record?.physician?.map((p) => p.name).filter(Boolean);

        return (
          <div
            className="cursor"
            onClick={() => {
              setPhysicianData(record.physician);
              setPhysicianDetailModal(true);
            }}
          >
            <Avatar.Group
              maxCount={2}
              maxStyle={{ color: "#f56a00", backgroundColor: "#fde3cf" }}
            >
              {names.map((p, index) => (
                <Avatar
                  key={index}
                  style={{
                    backgroundColor: "var(--border-color)",
                    color: "var(--primary-text-color)",
                  }}
                >
                  {capitalizeFirstLetter(p?.[0]) || "?"}
                </Avatar>
              ))}
            </Avatar.Group>
          </div>
        );
      },
    },

    // {
    //   title: <div className="font-14 text-center"> General Education Video</div>,
    //   dataIndex: "generalLibrary",
    //   key: "generalLibrary",
    //   align: "center",
    //   width: 120,
    //   render: (generalLibrary, record) => {
    //     const isMasterVideo = generalLibrary === true;
    //     return (
    //       <Tag
    //         color={isMasterVideo ? "green" : "blue"}
    //         style={{
    //           fontWeight: 500,
    //           padding: "4px 8px",
    //           borderRadius: "4px",
    //         }}
    //       >
    //         {isMasterVideo ? "Yes" : "No"}
    //       </Tag>
    //     );
    //   },
    //   sorter: (a, b) => {
    //     const aIsMaster = a.generalLibrary === false;
    //     const bIsMaster = b.generalLibrary === false;
    //     return aIsMaster === bIsMaster ? 0 : aIsMaster ? -1 : 1;
    //   },
    // },

    {
      title: <div className="font-14 text-center">Video Type</div>,
      dataIndex: "referenceMasterVideoId",
      key: "type",
      align: "center",
      width: 150,
      render: (referenceMasterVideoId, record) => {
        const isGeneralLibrary = record?.generalLibrary
        const isCloned = record.referenceMasterVideoId;

        if(record?.videoType === "ccm"){
          return (
            <Tag
              color="purple"
              style={{
                fontWeight: 500,
                padding: "4px 8px",
                borderRadius: "4px",
              }}
            >
              CCM
            </Tag>
          )
        }
        return (
          <Tag
            color={!isGeneralLibrary ? isCloned ? "orange" : "purple" : "green"}
            style={{
              fontWeight: 500,
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            {!isGeneralLibrary ? isCloned ? "AI Enhanced" : "Master" : 'Patient Education'}
          </Tag>
        )
      },
      sorter: (a, b) => {
        const aIsCloned = !!a.referenceMasterVideoId;
        const bIsCloned = !!b.referenceMasterVideoId;
        return aIsCloned === bIsCloned ? 0 : aIsCloned ? -1 : 1;
      },
    },

    {
      title: <div className="font-14 text-center">Specialty</div>,
      dataIndex: "specialty",
      key: "specialtyText",
      width: 170,
      ellipsis: true,
      sorter: (a, b) =>
        (a.specialtyText || "").localeCompare(b.specialtyText || ""),
      // render: (_, record) => record.specialty,
    },

    {
      title: <div className="font-14 text-center">CPT Codes</div>,
      dataIndex: "tags",
      key: "tags",
      align: "center",
      width: 220,
      ellipsis: true,
      render: (tags) => (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
          {tags?.map((tag) => (
            <Tag key={tag}>{tag}</Tag>
          ))}
        </div>
      ),
    },
    {
      title: <div className="font-14">Created At</div>,
      dataIndex: "createdAt",
      key: "createdAt",
      align: "center",
      width: 180,
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
    // {
    //   title: <div className="font-14">Uploaded At</div>,
    //   dataIndex: "uploadedAt",
    //   key: "uploadedAt",
    //   width: 200,
    //   sorter: (a, b) => new Date(a.uploadedAt) - new Date(b.uploadedAt),
    // },
    {
      title: <div className="font-14 text-center">Action</div>,
      dataIndex: "videoUrl",
      key: "videoUrl",
      width: 100,
      render: (url, record) => (
        <div className="d-flex justify-content-center gap-12" style={{ textAlign: "center" }}>
          <Tooltip title="View Video">
            <span
              style={{
                // border: "1px solid var(--border-color)",
                // backgroundColor: "rgb(168, 85, 247)",
                // color: "var(--primary-text-color)",
                // padding: "8px 12px",
                // borderRadius: " 999px",
                // fontSize: "0.9rem",
                fontWeight: 600,
                cursor: "pointer",
                marginRight: "4px"
              }}
              onClick={() => handleVideoPreview(record)}
              className="icon-button-view"
            >
              <EyeOutlined />
            </span>
          </Tooltip>
          <Tooltip title="Edit Video">
            <span
              style={{
                // border: "1px solid var(--border-color)",
                // backgroundColor: "rgb(168, 85, 247)",
                // color: "var(--primary-text-color)",
                // padding: "8px 12px",
                // borderRadius: " 999px",
                // fontSize: "0.9rem",
                fontWeight: 600,
                cursor: "pointer",
              }}
              onClick={() => {
                setIsEdit(true);
                setSelectedVideoUrl(record);
                setIsModalVisible(true);
              }}
              className="icon-button-edit"
            >
              <EditOutlined />
            </span>
          </Tooltip>
        </div>
      ),
    },
    // {
    //   // title: <div className="font-14">Action</div>,
    //   dataIndex: "action",
    //   key: "action",
    //   // width: "15%",
    //   render: (_, record) =>
    //     isPhysician && selectedTab === "Requested" ? (
    //       <div className="d-flex gap-12">
    //         <CustomSecondaryButton onClick={() => handleReject(record.key)}>
    //           Reject
    //         </CustomSecondaryButton>
    //         <CustomButton onClick={() => handleApprove(record.key)}>
    //           Approve
    //         </CustomButton>
    //       </div>
    //     ) : null,
    // },
  ];

  const handleVideoPreview = (record) => {
    setSelectedVideo(record);
    setIsPreviewModalVisible(true);
  };

  const fetchVideos = async (searchInput = searchText) => {
    try {
      setLoading(true);
      const res = await videos.getVideos(
        pagination?.pageSize,
        pagination?.current,
        sortingColumn,
        searchInput,
        JSON.stringify(filterTab),
        videoTypeFilter,
        '',
        videoTypeSorting
      );

      if (res?.data?.videos?.results) {
        const processedData = processData(res?.data?.videos?.results || []);
        setAllVideos(processedData);
      }
      setCount(res?.data?.videos?.totalResults);
    } catch (error) {
      notify("error", "Failed to fetch videos");
    } finally {
      setLoading(false);
    }
  };

  const processData = (data) => {
    return data.map((item) => ({
      ...item,
      title: (
        <>
          <div
            className="cursor d-flex flex-column justify-start align-start"
            style={{ width: "100%", maxWidth: "100%" }}
          >
            <span 
              style={{
                width: "100%", 
                maxWidth: "100%",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                display: "block"
              }}
            >
              {capitalizeFirstLetter(item.title)}
            </span>
            {item?.description && (
              <span 
                style={{ 
                  width: "100%", 
                  maxWidth: "100%",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  display: "block"
                }}
              >
                {capitalizeFirstLetter(item.description)}
              </span>
            )}
          </div>
        </>
      ),
      specialty: item.specialty ? titleFormat(item.specialty) : item?.videoType === "ccm" ? "-" : "Not specified",
      key: item.id,
      generalLibrary: item.generalLibrary,
    }));
  };

  const fetchRequestedVideos = async () => {
    if (!isPhysician) return;

    try {
      setLoading(true);
      const res = await videos.getRequestedVideos();
      if (res?.data?.videos?.results) {
        setAllRequestedVideos(res.data.videos.results);
      }
    } catch (error) {
      notify("error", "Failed to fetch requested videos");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = useCallback(
    debounce((value) => {
      fetchVideos(value, true);
    }, 500),
    []
  );

  const handleReject = async (videoId) => {
    try {
      // await videos.rejectVideo(videoId);
      notify("success", "Video rejected successfully");
      fetchRequestedVideos();
    } catch (error) {
      notify("error", "Failed to reject video");
    }
  };

  const handleApprove = async (videoId) => {
    try {
      // await videos.approveVideo(videoId);
      notify("success", "Video approved successfully");
      fetchRequestedVideos();
    } catch (error) {
      notify("error", "Failed to approve video");
    }
  };

  const handleDeleteVideos = async () => {
    try {
      if (selectedRowKeys.length === 0) {
        notify("warning", "Please select videos to delete");
        return;
      }

      setIsDeleteModalVisible(true);
    } catch (error) {
      notify("error", "Failed to delete videos");
    }
  };

  const handleConfirmDelete = async () => {
    try {
      setDeleteLoading(true);
      await videos.deleteVideo({ videoIds: selectedRowKeys });
      notify("success", `${selectedRowKeys.length} video deleted successfully`);
      setSelectedRowKeys([]);
      fetchVideos();
      setIsDeleteModalVisible(false);
    } catch (error) {
      notify("error", "Failed to delete videos");
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleUploadSubmit = async (values, setProgress, isEdit, videoId) => {
    try {
      if (!isEdit) {
        setProgress(2);

        let body = {
          title: values?.title,
          description: values?.description,
          specialty: values?.specialty,
          tags: values?.videoType === 'ccm' ? values?.icdCodes : values?.cptCodes,
          generalLibrary: values?.isGeneralVideo,
          physician: values?.physician,
          customTags: values?.customTags,
          videoType: values?.videoType
          // videoType: values?
        };

        await videos.uploadVideos(values.videoFile.file, body);
        setIsModalVisible(false);
        notify("success", "Video uploaded successfully");
      } else {
        setProgress(2);

        let body = {
          title: values?.title,
          description: values?.description,
          specialty: values?.specialty,
          tags: values?.videoType === 'ccm' ? values?.icdCodes : values?.cptCodes,
          generalLibrary: values?.isGeneralVideo,
          physician: values?.physician,
          customTags: values?.customTags,
          videoType: values?.videoType

        };

        if (values.videoFile.file) {
          await videos.updateVideo(videoId, values.videoFile.file, body);
        } else {
          await videos.updateVideo(videoId, values.videoFile, body);
        }
        setIsModalVisible(false);
        notify("success", "Video updated successfully");
      }
      setProgress(0);
      fetchVideos();
    } catch (error) {
      setProgress(0);
      notify("error", "Failed to upload video");
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys),
  };

  const handleChangeTable = (a, b, c) => {
    const sortColumn = c?.column?.dataIndex;
    const sortOrder = c?.order;
    if (sortColumn === "referenceMasterVideoId") {

      setVideoTypeSorting(sortOrder === "ascend" ? "asc" : "desc")
      return ''
    }else{
      setVideoTypeSorting('')
    }

    if (sortColumn && sortOrder) {
      const normalizedOrder = sortOrder === "ascend" ? "asc" : "desc";
      setSortingColumn(`${sortColumn}:${normalizedOrder}`);
    } else {
      setSortingColumn("");
    }
  };

  const fetchAllVideos = async () => {
    try {
      const res = await apiGet(domainUrl(`/v1/video/all-video?limit=50&page=1`));
      setAllVideoSpecialty(res?.data?.videos?.results)
    } catch (error) { }
  };


  useEffect(() => {
    fetchAllVideos();
  }, []);

  useEffect(() => {
    if (allVideoSpecialty.length > 0 && videosList === null) {
      const tags = new Set();
      allVideoSpecialty?.filter((item) => {
        if (typeof item?.specialty === "string") {
          tags.add(item?.specialty);
        }
      });
      setVideosList([...tags]);
    }
  }, [allVideoSpecialty]);

  const formatVideoData = (videoList) => {
    return videoList.map((item) => {
      return {
        key: item.id,
        title: item.title,
        description: item.description || "-",
        physician: item?.physician.length ? item?.physician : "Not Assigned",
        specialty: item?.specialty ? (
          <div style={{ textAlign: "center" }}>{item?.specialty}</div>
        ) : (
          <div style={{ textAlign: "center" }}>-</div>
        ),
        videoUrl: item.video || item.videoUrl,
        createdAt: moment(item?.createdAt).format("DD-MMM-YYYY"),
        uploadedAt:
          moment(item?.uploadedAt).format("DD-MMM-YYYY") || item.createdAt,
        tags: item?.tags || [],
        customTags: item?.customTags || [],
        generalLibrary: item.generalLibrary,
        referenceMasterVideoId: item.referenceMasterVideoId,
        videoType: item.videoType,
      };
    });
  };

  const getFilteredData = () => {
    const dataSource = selectedTab === "List" ? allVideos : allRequestedVideos;

    if (!searchText) return formatVideoData(dataSource);

    return formatVideoData(dataSource)
  };

  const fetchAllPhysician = async () => {
    try {
      const res = await physicianService.getAll();
      const uniqueNames = [...new Set(res?.data?.results.map(item => item?.name))];
      setAllPhysician(uniqueNames);
    } catch (error) { }
  };

  useEffect(() => {
    fetchAllPhysician();
  }, []);

  useEffect(() => {
    fetchVideos();
    if (isPhysician) {
      fetchRequestedVideos();
    }
  }, [pagination, sortingColumn, filterTab, videoTypeFilter, videoTypeSorting]);

  const data = allVideos.length;

  return (
    <>
      <TopSection>
        <Row className="custom-header" style={{ marginBottom: "10px" }}>
          <Col className="header-item">
            <CustomTitle>Video Library</CustomTitle>
            <CustomSubTitle>
              Manage medical education videos.
            </CustomSubTitle>
          </Col>
        </Row>
      </TopSection>
      {isPhysician && (
        <SegmentWrapper>
          <Row
            gutter={[0, 32]}
            style={{ marginTop: "25px", marginLeft: "62px" }}
          >
            <Segmented
              options={["List", "Requested"]}
              block
              value={selectedTab}
              onChange={setSelectedTab}
              style={{ width: "20%" }}
            />
          </Row>
        </SegmentWrapper>
      )}

      <Wrapper
        gutter={[0, 32]}
        style={{
          borderRadius: "10px",
          border: "1px solid var(--border-color)",
          marginTop: "10px",
          marginBottom: "32px",
        }}
      >
        <Col span={24} style={{ padding: "0px 24px" }}>
          <StyledHeader>
            <Col
              span={24}
              className="d-flex"
              style={{ justifyContent: "space-between" }}
            >
              <div className="d-flex  gap-12" style={{ width: "100%", justifyContent: 'start' }}>
                <CustomSearchContainer>
                  <FiSearch
                    style={{ position: "absolute", zIndex: 1 }}
                    className="icon ml-5"
                  />
                  <Input
                    // className="search-bar"
                    placeholder="Search videos by title..."
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      handleSearch(e.target.value);
                    }}
                    value={searchText}
                  />
                </CustomSearchContainer>
                <Filter
                  show={show}
                  setShow={setShow}
                  data={[
                    {
                      title: "Specialty",
                      list: videosList,
                      filterList: filterTab,
                      setFilterList: setFilterTab,
                    },
                    // {
                    //   title: "Physicians",
                    //   list: allPhysician,
                    //   filterList: selectedPhysician,
                    //   setFilterList: setSelectedPhysician,
                    // },
                    {
                      title: "Video Type",
                      list: ['master', 'ai enhanced', 'patient education', 'ccm'],
                      filterList: videoTypeFilter,
                      setFilterList: setVideoTypeFilter,
                      tagColors: {
                        'master': { label: 'Master', color: 'purple' },
                        'ai enhanced': { label: 'AI Enhanced', color: 'orange' },
                        'patient education': { label: 'Patient Education', color: 'green' },
                        'ccm': { label: 'CCM', color: 'purple' }
                      }
                    }
                  ]}
                />
              </div>
              <div className="d-flex gap-12">
                {/* {selectedRowKeys.length > 0 && (
                  <Button
                    className="upload-button"
                    type="primary"
                    onClick={() => setIsAssignModal(true)}
                  >
                    Assign Videos
                  </Button>
                )} */}
                {selectedRowKeys.length > 0 && globalRoles.SUPERADMIN === user?.role && (
                  <Button
                    className="upload-button"
                    danger
                    icon={<DeleteOutlined size={18} />}
                    onClick={handleDeleteVideos}
                  >
                    Delete ({selectedRowKeys.length})
                  </Button>
                )}
                <Button
                  className="upload-button"
                  type="primary"
                  icon={<UploadOutlined size={22} />}
                  onClick={() => setIsModalVisible(true)}
                >
                  Upload
                </Button>
              </div>
            </Col>
          </StyledHeader>
        </Col>

        <Col span={24} style={{ flex: 1, padding: "0px 24px" }}>
          <StyledTable
            loading={loading}
            columns={columns}
            dataSource={getFilteredData()}
            rowKey="key"
            rowSelection={isLibraryManager || superAdmin ? rowSelection : undefined}
            scroll={
              data?.length > 0 ? { y: `calc(100vh - 320px)`, x: 1500 } : null
            }
            pagination={{
              current: pagination?.current,
              pageSize: pagination?.pageSize,
              showSizeChanger: true,
              pageSizeOptions: [25, 50, 100],
              onShowSizeChange: (current, size) => {
                setPagination({
                  ...pagination,
                  current,
                  pageSize: size,
                });
              },
              total: count,
              showTotal: (total, range) =>
                `${range[0]} - ${range[1]} of ${total} videos`,
              showQuickJumper: false,
              showLessItems: true,
              itemRender: (page, type, originalElement) => {
                if (type === "prev") {
                  return (
                    <Button
                      type="text"
                      disabled={pagination?.current === 1}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (pagination?.current > 1) {
                          setPagination((prev) => ({
                            ...prev,
                            current: prev.current - 1,
                          }));
                        }
                      }}
                    >
                      Previous
                    </Button>
                  );
                }
                if (type === "next") {
                  const maxPage = Math.ceil(count / pagination?.pageSize);
                  return (
                    <Button
                      type="text"
                      disabled={pagination?.current === maxPage}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (pagination?.current < maxPage) {
                          setPagination((prev) => ({
                            ...prev,
                            current: prev.current + 1,
                          }));
                        }
                      }}
                    >
                      Next
                    </Button>
                  );
                }
                return originalElement;
              },
            }}
            onChange={handleChangeTable}
          />
        </Col>

        {isModalVisible && (
          <UploadVideoModal
            isVisible={isModalVisible}
            onCancel={() => setIsModalVisible(false)}
            onSubmit={handleUploadSubmit}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            selectedVideoUrl={selectedVideoUrl}
          />
        )}

        {isAssignModal && (
          <AssignVideoModal
            isOpen={isAssignModal}
            setOpen={setIsAssignModal}
            onClose={() => setIsAssignModal(false)}
            selectedVideos={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
            fetchVideos={fetchVideos}
          />
        )}
      </Wrapper>
      {isPreviewModalVisible && (
        <VideoPreviewModal
          isVisible={isPreviewModalVisible}
          setIsVisible={setIsPreviewModalVisible}
          onClose={() => {
            setIsPreviewModalVisible(false);
            setSelectedVideo(null);
          }}
          videoUrl={selectedVideo?.videoUrl}
          title={selectedVideo?.title?.props?.children?.props?.children[0].props.children}
        />
      )}
      {physicianDetailModal && (
        <AssisgnedVideoModal
          isOpen={physicianDetailModal}
          setOpen={() => setPhysicianDetailModal(false)}
          physicianData={physicianData}
        />
      )}
      {
        isDeleteModalVisible && (
          <DeleteConfirmationModal
            isOpen={isDeleteModalVisible}
            setOpen={() => setIsDeleteModalVisible(false)}
            onConfiem={handleConfirmDelete}
            loading={deleteLoading}
            title={`Delete ${selectedRowKeys.length} video(s)`}

          />
        )
      }
    </>
  );
};

export default VideoLibraryPage;
